require('./bootstrap');
require('./jquery.sticky');
require('./slick');
require('./jquery.easing.1.3');

$(".sticky-nav").sticky({topSpacing: 0});

$(window).scroll(function () {
    let st = $(this).scrollTop();
    if (st > 100) {
        $('.sticky-nav').addClass('shrink');
    } else {
        $('.sticky-nav').removeClass('shrink');
    }
});

$("body").on("click", ".smooth-scroll[href^='#']", function (e) {
    e.preventDefault();
    let hash = this.hash;
    $('html, body').animate({
        'scrollTop': $(hash).offset().top - 80
    }, 2000, 'easeInOutExpo', function () {
        window.location.hash = hash;
    });
});

if ($('.logos').length > 0) {
    $('.logos').slick({
        slidesToShow: 8,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 6
            }
        }, {
            breakpoint: 520,
            settings: {
                slidesToShow: 4
            }
        }]
    });
}

if ($('.reviews').length > 0) {
    $('.reviews').slick({
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 6000,
        speed: 1200,
        slidesToShow: 1,
        adaptiveHeight: true
    });
}

if ($('.tweets').length > 0) {
    $('.tweets').slick({
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 6000,
        speed: 1200,
        slidesToShow: 1,
        adaptiveHeight: true
    });
}

function initContactForm() {

    var requiredInputs = $('#contactForm').find('input[data-required="true"], textarea[data-required="true"]').toArray();

    var isValidForm = function () {
        var toReturn;

        requiredInputs.forEach(function (element, index) {
            if (!$(element).val()) {
                toReturn = false;
            } else {
                toReturn = true;
            }
        });

        return toReturn;
    };

    $('#contactForm').on('submit', function (event) {

        event.preventDefault();

        requiredInputs.forEach(function (element, index) {
            if (!$(element).val()) {
                $(element).parent('.form-group').addClass('has-error');
            } else {
                $(element).parent('.form-group').removeClass('has-error');
            }
        });

        if (isValidForm()) {
            $.ajax({
                url: $(this).attr('action'),
                type: 'POST',
                data: $(this).serialize(),
            })
                .done(function () {
                    let message = $('#contactForm').data('success-text') || 'Your message has been sent. We will get back to you shortly!';
                    let succesTemplate = '<div role="alert" class="alert alert-success alert-outline">' + message + '</div>';
                    $('#contactForm input, #contactForm textarea, #contactForm select, #contactForm button').attr('disabled', 'disabled');
                    $('#contactForm .alert').fadeOut(300);
                    $(succesTemplate).insertBefore($('#contactForm .form-submit'));
                })
                .fail(function () {
                    let message = $('#contactForm').data('error-text') || 'There was an error. Try again later.';
                    let errorTemplate = '<div role="alert" class="alert alert-danger alert-outline">' + message + '</div>';
                    $('#contactForm .alert').fadeOut(300);
                    $(errorTemplate).insertBefore($('#contactForm .form-submit'));
                })
        } else {
            console.log('fail');
        }

    });

    $('#contactForm input, #contactForm textarea').on('keyup', function (event) {
        event.preventDefault();
        if ($(this).val()) {
            $(this).parent('.form-group').removeClass('has-error');
        }
    });
}

initContactForm();
